import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../Header/Navbar';
import Footer from '../Footer/Footer';
import BackToTop from '../BackToTop/BackToTop';
import Topbar from '../Header/Topbar';
import ProductGrid from './ProductGrid';
import Pagination from './Pagination';
import SEO from '../SEO/SEO';
import './Products.css';

const ExideProducts = () => {
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');

  const exideCategories = [
    { id: 'motor-cycle', name: 'EXIDE XPLORE - Motor Cycle Batteries', brand: 'exide' },
    { id: 'car', name: 'Exide Car Battery', brand: 'exide' },
    { id: 'heavy-vehicles', name: 'Exide Heavy Vehicles Battery', brand: 'exide' },
    { id: 'invamaster', name: 'EXIDE INVAMASTER', brand: 'exide' },
    { id: 'invatubular', name: 'EXIDE INVATUBULAR', brand: 'exide' },
    { id: 'instabrite', name: 'EXIDE INSTABRITE', brand: 'exide' },
    { id: 'solar', name: 'EXIDE TUBULAR SOLAR BATTERY', brand: 'exide' }
  ];

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const clearSearch = () => {
    setSearchQuery('');
    setCurrentPage(1);
  };

  const getTotalProducts = () => {
    const productCounts = {
      'motor-cycle': 9,
      'car': 19,
      'heavy-vehicles': 7,
      'invamaster': 8,
      'invatubular': 5,
      'instabrite': 7,
      'solar': 11
    };
    
    return Object.values(productCounts).reduce((sum, count) => sum + count, 0);
  };

  return (
    <>
      <SEO 
        title="Exide Batteries"
        description="Explore our range of Exide batteries including motor cycle, car, heavy vehicle, inverter, and solar batteries at Galaxy Power System, Chidambaram."
        keywords="exide battery dealer, exide car battery, exide bike battery, exide inverter battery chidambaram"
        canonicalUrl="https://galaxypowersystems.com/exide-products"
        breadcrumbs={[
          { name: 'Home', url: '/' },
          { name: 'Exide Products', url: '/exide-products' }
        ]}
      />
      <Topbar />
      <Navbar />
      <div className="container-fluid product py-5" id="products">
        <div className="container py-5">
          {/* Brand Header */}
          <div className="row mb-5">
            <div className="col-12 text-center">
              <h1 className="display-5 mb-3" style={{ color: '#DE400E' }}>
                <i className="fas fa-bolt me-2"></i> Exide Batteries
              </h1>
              <p className="lead text-muted mb-4">
                Exide Industries Limited is India's largest manufacturer of lead-acid batteries. 
                Exide produces a wide range of batteries for automotive, industrial, and inverter applications.
              </p>
            </div>
          </div>

          {/* Search and Info Bar */}
          <div className="row g-4 align-items-center mb-5">
            <div className="col-lg-4 col-md-12">
              <h3 className="mb-0">All Exide Products</h3>
            </div>
            
            <div className="col-lg-5 col-md-8">
              <div className="position-relative">
                <div className="d-flex border rounded-pill" style={{ backgroundColor: '#fff', borderColor: '#ddd' }}>
                  <input 
                    className="form-control border-0 rounded-pill w-100 py-2" 
                    type="text"
                    placeholder="Search Exide products..."
                    value={searchQuery}
                    onChange={handleSearch}
                    style={{ fontSize: '14px' }}
                  />
                  {searchQuery && (
                    <button 
                      type="button" 
                      className="btn btn-link text-danger"
                      onClick={clearSearch}
                      style={{ border: '0', fontSize: '14px' }}
                    >
                      <i className="fas fa-times"></i>
                    </button>
                  )}
                </div>
              </div>
            </div>
            
            <div className="col-lg-3 col-md-4 text-end">
              <div className="badge bg-danger rounded-pill py-2 px-4">
                Total Products: {getTotalProducts()}
              </div>
            </div>
          </div>
          
          {/* Products Grid */}
          <div className="tab-content">
            <ProductGrid 
              categories={exideCategories} 
              currentPage={currentPage} 
              brand="exide"
              searchQuery={searchQuery}
            />
            
            {/* Pagination */}
            {!searchQuery && (
              <Pagination 
                totalPages={exideCategories.length}
                currentPage={currentPage}
                onPageChange={setCurrentPage}
                paginationId="exide-pagination"
              />
            )}
          </div>
        </div>
      </div>
      <BackToTop />
      <Footer />
    </>
  );
};

export default ExideProducts;